// extracted by mini-css-extract-plugin
export default {"layout":"XymozaXZ0_tABz3hdKvG","main":"OKc6kujdXNvUmWAeb4yg"};